export class EventReservationSource {
    /**
   * Reservation from file integration with FTP through IVE.
   */
    static readonly FILE = 'FILE';
    /**
     * Manual reservation created by the UI user.
     */
    static readonly MANUAL = 'MANUAL';
    /**
     * Reservation from uploaded spreadsheet.
     */
    static readonly UPLOADED = 'UPLOADED';
    /**
     * Reservation created from an unmatched RSVP.
     */
    static readonly RSVP = 'RSVP';
    /**
     * Out-of-block reservation.
     */
    static readonly OUT_OF_BLOCK = 'OUT_OF_BLOCK';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-reservation-source.ts